import { MonthYearBox } from '@apply/components';
import { CardFocusType } from '../../../../../constants/CardFocusType';
import { useCustomPaymentCardFocus, useCustomPaymentCardMonthYear } from '../../../../../fields/CustomPaymentFields';

interface CardMonthYearParameters {
    customPaymentId: string;
    disabled: boolean;
}

export const CardMonthYear: React.FC<CardMonthYearParameters> = ({ customPaymentId, disabled }) => {
    const [cardMonthYear, set_cardMonthYear] = useCustomPaymentCardMonthYear(customPaymentId);
    const [, set_cardFocus] = useCustomPaymentCardFocus(customPaymentId);

    return (
        <MonthYearBox
            name='expiry'
            label='Expiration'
            value={cardMonthYear}
            onChangeWithMask={(value) => set_cardMonthYear(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.Expiration)}
            disabled={disabled}
        />
    );
};
